import { all } from 'redux-saga/effects';

import { watchFetchTopic } from './fetch';

export function* topicSaga() {
  yield all([watchFetchTopic()]);
}
